import { Client } from "./_clientService";

async function createTutorialConfig(operatorId: string) {
  try {
    const resp = await new (Client as any)({
      path: "/tutorial/create",
      payload: { operatorId },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function getTutorialConfig(operatorId: string) {
  try {
    const resp = await new (Client as any)({
      path: `/tutorial/config/${operatorId}`,
    }).get();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function getTutorialList() {
  try {
    const resp = await new (Client as any)({
      path: "/tutorial/list",
    }).get();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function uploadTutorialVideo(
  operatorId: string,
  languageCode: string,
  file: File,
) {
  try {
    // Step 1: Request a presigned URL. No DB record is created yet.
    const presignedResp = await new (Client as any)({
      path: "/tutorial/upload",
      payload: {
        operatorId,
        languageCode,
        fileType: file.type,
        fileSize: file.size,
      },
    }).post();

    const { fileUploadUrl } = presignedResp?.data || {};

    if (!fileUploadUrl) {
      throw new Error("Failed to get upload URL");
    }

    // Step 2: Upload the file directly to S3 using the presigned URL.
    let uploadResponse: Response;
    try {
      uploadResponse = await fetch(fileUploadUrl, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type,
        },
      });
    } catch {
      throw new Error(
        "Could not upload the video to storage. Please check your connection and try again.",
      );
    }

    if (!uploadResponse.ok) {
      throw new Error(
        `Failed to upload video to storage (status ${uploadResponse.status}). Please try again.`,
      );
    }

    // Step 3: Confirm the upload. The backend verifies the file exists in
    // storage and only then creates the DB record. If this fails, no record
    // is saved and the video will not appear as uploaded.
    const confirmResp = await new (Client as any)({
      path: "/tutorial/confirm",
      payload: {
        operatorId,
        languageCode,
        fileType: file.type,
      },
    }).post();

    return { data: confirmResp?.data };
  } catch (error) {
    throw error;
  }
}

async function deleteTutorialVideo(operatorId: string, languageCode: string) {
  try {
    const resp = await new (Client as any)({
      path: `/tutorial/video/${operatorId}/${languageCode}`,
    }).delete();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function deleteTutorialConfig(operatorId: string) {
  try {
    const resp = await new (Client as any)({
      path: `/tutorial/config/${operatorId}`,
    }).delete();
    return resp;
  } catch (error) {
    throw error;
  }
}

export {
  createTutorialConfig,
  getTutorialConfig,
  getTutorialList,
  uploadTutorialVideo,
  deleteTutorialVideo,
  deleteTutorialConfig,
};
